module.exports = __webpack_public_path__ + "img/research.7a8b4f3f.svg";